import { useEffect, useState } from "react";
import "./Activity.css";

// Live coding activity — auto-generated from real GitHub data.
const GH_USER = "MDAnsaar25";

// Nord-native contribution grid: fetches real data and renders dark squares.
// No external chart image — matches the theme exactly.
function ContributionGrid() {
  const [weeks, setWeeks] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetch(`https://github-contributions-api.jogruber.de/v4/${GH_USER}?y=last`)
      .then((r) => r.json())
      .then((data) => {
        const days = data.contributions || [];
        // group into weeks of 7
        const w = [];
        for (let i = 0; i < days.length; i += 7) w.push(days.slice(i, i + 7));
        setWeeks(w);
      })
      .catch(() => setFailed(true));
  }, []);

  if (failed) return null;
  if (!weeks) return <div className="grid-loading">loading contributions…</div>;

  // mint intensity scale (level 0–4)
  const scale = ["#16241d", "#1f6b47", "#28a86c", "#33d98a", "#3dffa2"];

  const cols = weeks.length;
  const CELL = 11;
  const GAP = 3;
  const STEP = CELL + GAP;
  const PAD_LEFT = 30;   // room for day labels
  const PAD_TOP = 16;    // room for month labels
  const W = PAD_LEFT + cols * STEP;
  const H = PAD_TOP + 7 * STEP;

  const dayLabels = [
    { i: 1, t: "Mon" },
    { i: 3, t: "Wed" },
    { i: 5, t: "Fri" },
  ];

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  // month label appears at the first week where the month changes
  const monthMarks = [];
  let lastMonth = -1;
  weeks.forEach((week, ci) => {
    const first = week[0];
    if (!first) return;
    const m = new Date(first.date).getMonth();
    if (m !== lastMonth) {
      monthMarks.push({ ci, label: months[m] });
      lastMonth = m;
    }
  });

  return (
    <div className="contrib-wrap">
      <svg
        className="contrib-svg"
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="xMinYMin meet"
        role="img"
        aria-label="GitHub contribution graph"
      >
        {/* month labels */}
        {monthMarks.map((m, k) => (
          <text
            key={`m-${k}`}
            x={PAD_LEFT + m.ci * STEP}
            y={10}
            className="contrib-axis"
          >
            {m.label}
          </text>
        ))}

        {/* day labels */}
        {dayLabels.map((d) => (
          <text
            key={`d-${d.i}`}
            x={0}
            y={PAD_TOP + d.i * STEP + CELL - 1}
            className="contrib-axis"
          >
            {d.t}
          </text>
        ))}

        {/* squares */}
        {weeks.map((week, ci) =>
          week.map((day, ri) => (
            <rect
              key={`${ci}-${ri}`}
              x={PAD_LEFT + ci * STEP}
              y={PAD_TOP + ri * STEP}
              width={CELL}
              height={CELL}
              rx={2}
              fill={scale[day.level] || scale[0]}
            >
              <title>{`${day.date}: ${day.count} contributions`}</title>
            </rect>
          ))
        )}
      </svg>
      <div className="contrib-legend">
        <span>less</span>
        <span className="lg-sq" style={{ background: "#16241d" }} />
        <span className="lg-sq" style={{ background: "#1f6b47" }} />
        <span className="lg-sq" style={{ background: "#28a86c" }} />
        <span className="lg-sq" style={{ background: "#33d98a" }} />
        <span className="lg-sq" style={{ background: "#3dffa2" }} />
        <span>more</span>
      </div>
    </div>
  );
}

const Activity = () => {
  return (
    <div className="sec" id="activity">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> live activity — open source</div>

        {/* GitHub stats card — auto-generated from repos */}
        <div className="act-statcard" data-aos="fade-up">
          <img
            className="act-stats-img"
            src={`https://github-readme-stats.vercel.app/api?username=${GH_USER}&show_icons=true&hide_border=true&title_color=3dffa2&icon_color=3dffa2&text_color=c8f7e0&bg_color=0a0f0d&hide=issues`}
            alt="GitHub stats"
            loading="lazy"
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <img
            className="act-stats-img"
            src={`https://github-readme-stats.vercel.app/api/top-langs/?username=${GH_USER}&layout=compact&hide_border=true&title_color=3dffa2&text_color=c8f7e0&bg_color=0a0f0d&langs_count=6`}
            alt="Top languages"
            loading="lazy"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        </div>

        {/* GitHub contribution heatmap — Nord-native, self-rendered from real data */}
        <div className="act-card act-gh" data-aos="fade-up">
          <div className="act-head">
            <span className="act-label">git contributions</span>
            <a className="act-link" href={`https://github.com/${GH_USER}`} target="_blank" rel="noopener noreferrer">
              @{GH_USER} →
            </a>
          </div>
          <ContributionGrid />
          <p className="act-note">updates with every commit · the graph is still filling in</p>
        </div>
      </div>
    </div>
  );
};

export default Activity;